import { i18n } from '@lt/localization';
import React from 'react';
import styled from 'styled-components';

import { EmptyHotelMap } from '@lt/components/icons-react/map';
import type { EmptyMapProps } from './types';
import { EMPTY_MAP_CONTAINER_TEST_ID } from './constants';

/*
    Добавил в дефолт высоту, основываясь на том,
    что в случае пустого ответа об отелях
    слева появится контейнер такой же высоты с
    сообщением о том, что туров нет
*/
const defaultProps = {
  title: i18n.t('map.static.message.title'),
  description: i18n.t('map.static.message.ovelay'),
  height: 348,
};

export const EmptyMap = ({
  title = defaultProps.title,
  description = defaultProps.description,
  height = defaultProps.height,
  isMobile = false,
}: EmptyMapProps) => (
  <StyledContainer
    height={Number(height)}
    data-testid={EMPTY_MAP_CONTAINER_TEST_ID}
  >
    <StyledEmptyHotelMap />
    <StyledHeader isMobile={isMobile}>{title}</StyledHeader>
    <StyledText isMobile={isMobile}>{description}</StyledText>
  </StyledContainer>
);

const StyledContainer = styled.div<{ height: number }>`
  padding: 10px;
  display: flex;
  height: ${({ height }) => height}px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledHeader = styled.div<{ isMobile: boolean }>`
  margin-bottom: 8px;
  text-align: center;
  font-size: ${({ isMobile }) => (isMobile ? '18' : '22')}px;
  font-weight: bold;
  color: ${(props) => props.theme.colors.blackBase};
`;

const StyledText = styled.div<{ isMobile?: boolean }>`
  font-size: ${(props) => (props.isMobile ? '13' : '14')}px;
  text-align: center;
  white-space: pre-line;
  color: ${(props) => props.theme.colors.blackLight};
`;

const StyledEmptyHotelMap = styled(EmptyHotelMap)`
  width: 152px;
`;
